<template>
  <div>
    <my-menu menu-name="discovery"></my-menu>

    <swiper :options="swiperOption" ref="swiper1">
      <swiper-slide>
        <img src="../../assets/images/gzheader.png" style="width:100%;height:600px;" />
      </swiper-slide>
      <swiper-slide>
        <img src="../../assets/images/czheader.png" style="width:100%;height:600px;" />
      </swiper-slide>
      <swiper-slide>
        <img src="../../assets/images/cz1.png" style="width:100%;height:600px;" />
      </swiper-slide>
      <swiper-slide>
        <img src="../../assets/images/gzheader.png" style="width:100%;height:600px;" />
      </swiper-slide>
  
      <div class="swiper-pagination"  slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>   
    </swiper>

    <section class="d_content">
      <div class="d_navigation">
        <span class="nav_title">维学课堂</span>
        <ul>
          <li>
            <a href="#">查看更多</a>
          </li>
        </ul>
      </div>
      <ul class="cr_list">
        <li v-for="item in classes" v-bind:key="item.id">
          <router-link :to="{name: 'ClassDetail',params: {id: item.id}}">
            <img v-lazy="item.img_url" />
            <div class="class_info">
              <p class="class_title">{{item.title}}</p>
              <p class="class_date">{{item.date}}</p>
              <p class="class_content">{{item.desc}}</p>
            </div>
          </router-link>
        </li>
      </ul>
      <div class="clear"></div>
      <!-- 废除 -->
<!-- 
      <div class="d_navigation">
        <span class="nav_title">看视频学英语</span>
        <ul>
          <li>
            <a href="#">查看更多</a>
          </li>
        </ul>
      </div>
      <ul class="vidio_list">
        <li>
          <a href="#">
            <img src="../../assets/images/discovery/play.png" />
            <div class="vidio_thumb">
              <p class="thumb_title">如何学习日常用语</p>
              <div class="thumb_date">
                <span>2017-03-12</span>
                <span class="thumb_time">03.25</span>
                <img class="clock" src="../../assets/images/discovery/clock.png" />
              </div>
            </div>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="../../assets/images/discovery/play.png" />
            <div class="vidio_thumb">
              <p class="thumb_title">如何学习日常用语</p>
              <div class="thumb_date">
                <span>2017-03-12</span>
                <span class="thumb_time">03.25</span>
                <img class="clock" src="../../assets/images/discovery/clock.png" />
              </div>
            </div>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="../../assets/images/discovery/play.png" />
            <div class="vidio_thumb">
              <p class="thumb_title">如何学习日常用语</p>
              <div class="thumb_date">
                <span>2017-03-12</span>
                <span class="thumb_time">03.25</span>
                <img class="clock" src="../../assets/images/discovery/clock.png" />
              </div>
            </div>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="../../assets/images/discovery/play.png" />
            <div class="vidio_thumb">
              <p class="thumb_title">如何学习日常用语</p>
              <div class="thumb_date">
                <span>2017-03-12</span>
                <span class="thumb_time">03.25</span>
                <img class="clock" src="../../assets/images/discovery/clock.png" />
              </div>
            </div>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="../../assets/images/discovery/play.png" />
            <div class="vidio_thumb">
              <p class="thumb_title">如何学习日常用语</p>
              <div class="thumb_date">
                <span>2017-03-12</span>
                <span class="thumb_time">03.25</span>
                <img class="clock" src="../../assets/images/discovery/clock.png" />
              </div>
            </div>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="../../assets/images/discovery/play.png" />
            <div class="vidio_thumb">
              <p class="thumb_title">如何学习日常用语</p>
              <div class="thumb_date">
                <span>2017-03-12</span>
                <span class="thumb_time">03.25</span>
                <img class="clock" src="../../assets/images/discovery/clock.png" />
              </div>
            </div>
          </a>
        </li>
        <li>
          <a href="#">
            <img src="../../assets/images/discovery/play.png" />
            <div class="vidio_thumb">
              <p class="thumb_title">如何学习日常用语</p>
              <div class="thumb_date">
                <span>2017-03-12</span>
                <span class="thumb_time">03.25</span>
                <img class="clock" src="../../assets/images/discovery/clock.png" />
              </div>
            </div>
          </a>
        </li>
      </ul>
      <div class="clear"></div> 
      -->

      <div class="d_navigation">
        <span class="nav_title">听英语</span>
        <ul>
          <li>
            <a href="javascript:;" v-bind:class="{cur: audio.listen}" @click="slideTo(0)">听力</a>
          </li>
          <li>
            <a href="javascript:;" v-bind:class="{cur: audio.music}" @click="slideTo(1)">音乐</a>
          </li>
          <li>
            <a href="#">查看更多</a>
          </li>
        </ul>
      </div>
      <div class="listen_container">
        <a href="javascript:;" @click="leftSwiper" class="arrow_left"></a>
        <swiper :options="swiperOption2" ref="swiper2" class="swiper-container listen_list">
          <swiper-slide class="swiper-slide">
            <div class="slide">
              <a href="#">
                <div class="listen_cover">
                  <img src="../../assets/images/discovery/music.png" />
                </div>
                <div class="listen_title">高一听力</div>
              </a>
              <a href="#">
                <div class="listen_cover">
                  <img src="../../assets/images/discovery/music.png" />
                </div>
                <div class="listen_title">初一听力</div>
              </a>
              <a href="#">
                <div class="listen_cover">
                  <img src="../../assets/images/discovery/music.png" />
                </div>
                <div class="listen_title">高二听力</div>
              </a>
              <a href="#">
                <div class="listen_cover">
                  <img src="../../assets/images/discovery/music.png" />
                </div>
                <div class="listen_title">高三听力</div>
              </a>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper-slide">
            <div class="slide">
              <a href="#">
                <div class="listen_cover">
                  <img src="../../assets/images/discovery/listen.png" />
                </div>
                <div class="listen_title">Deaf Havan</div>
              </a>
              <a href="#">
                <div class="listen_cover">
                  <img src="../../assets/images/discovery/listen.png" />
                </div>
                <div class="listen_title">Deaf Havan</div>
              </a>
              <a href="#">
                <div class="listen_cover">
                  <img src="../../assets/images/discovery/listen.png" />
                </div>
                <div class="listen_title">Deaf Havan</div>
              </a>
              <a href="#">
                <div class="listen_cover">
                  <img src="../../assets/images/discovery/listen.png" />
                </div>
                <div class="listen_title">Deaf Havan</div>
              </a>
            </div>
          </swiper-slide>
        </swiper>
        <a href="javascript:;" @click="rightSwiper" class="arrow_right"></a>
      </div>
      <div class="clear"></div>

      <div class="d_navigation">
        <span class="nav_title">推荐文章</span>
        <ul>
          <li>
            <a href="#">查看更多</a>
          </li>
        </ul>
      </div>
      <ul class="article_list">
        <li v-for="item in articles" v-lazy:background-image="item.img_url" v-bind:key="item.id">
          <router-link :to="{name:'ArticleDetail',params:{id:item.id}}">
            <div class="vidio_thumb">
              <p class="thumb_title articl_title">{{item.title}}</p>
              <p>{{item.date}}</p>
            </div>
          </router-link>
        </li>
      </ul>
      <div class="clear"></div>
    </section>

    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyFooter from '@/components/Footer'
  import MyMenu from '@/components/Menu'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  import Classes from '@/assets/data/classes'
  import Articles from '@/assets/data/articles'

  export default {
    data () {
      return {
        swiperOption: {
          autoplay: 1000,
          // direction: 'vertical',
          autoHeight: true,
          pagination: '.swiper-pagination',
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next'
        },
        swiperOption2: {
        },
        audio: {
          music: false,
          listen: true
        },
        classes: [],
        articles: []
      }
    },
    components: {
      MyFooter,
      MyMenu,
      swiper,
      swiperSlide
    },
    created () {
      if (typeof Classes.classes !== 'undefined') {
        this.classes = Classes.classes.slice(0, 4)
      }

      if (typeof Articles.articles !== 'undefined') {
        this.articles = Articles.articles.slice(0, 6)
      }
    },
    computed: {
      swiper1 () {
        return this.$refs.swiper1.swiper
      },
      swiper2 () {
        return this.$refs.swiper2.swiper
      }
    },
    methods: {
      rightSwiper () {
        if (this.swiper2.isEnd) this.swiper2.slideTo(0)
        else this.swiper2.slideNext()

        this.slideTo(this.swiper2.realIndex)
      },
      leftSwiper () {
        if (this.swiper2.isBeginning) this.swiper2.slideTo(this.swiper2.slides.length - 1)
        else this.swiper2.slidePrev()

        this.slideTo(this.swiper2.realIndex)
      },
      slideTo (index) {
        if (index === 0) {
          this.audio.listen = true
          this.audio.music = false
        } else {
          this.audio.listen = false
          this.audio.music = true
        }
        this.swiper2.slideTo(index)
      }
    }
  }
</script>

<style scoped>
   @import '../../assets/css/swiper.min.css'; 

  body {
    background-color: #f0f0f0;
  }
</style>




// WEBPACK FOOTER //
// Index.vue?621e92ad